import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { getAssetUrl } from '@on3/ui-lib/utils/images';

interface ISiteLogo extends React.ImgHTMLAttributes<HTMLImageElement> {
  alternate?: boolean;
}
export const SiteLogo = ({ alternate = false, ...props }: ISiteLogo) => {
  const { currentSite } = useSite();
  const name =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name ?? '';
  const asset = alternate
    ? currentSite.alternateLogo
    : currentSite.defaultAssetRes;
  const source = getAssetUrl(asset);

  return <img alt={name} src={source || ''} title={name} {...props} />;
};
